import {commonActions} from '../../actions/commonActions';
import {orderSetList,orderSetListForExcel} from '../../actions/orderActions';
import {connect} from 'react-redux';
import List from '../../components/report/Tickets';
import {API_FETCH} from '../../services/FetchService';
import {alertConstants, commonConstants} from "../../constants";
import {list as areaList} from '../../containers/area/AreaListPage';
import {list as stateList} from '../../containers/area/StateListPage';
import {list as cityList} from '../../containers/area/CityListPage';
import {getItem as userInfo} from '../../containers/user/AddEditFormPage';
import {list as userList} from '../../containers/user/ListPage';

const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getListForExcel: (value) => {
        dispatch(listForExcel(value));
    },
    getUserInfo: (id) => {
        return(dispatch(userInfo(id)))
    },
    getAreaList : () => {
        return(dispatch(areaList()));
    },
    getStateList : (value) => {
        return(dispatch(stateList(value)));
    },
    getCityList : (value) => {
        return(dispatch(cityList(value)));
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});


export const listForExcel = (value) => {
    return (dispatch, getState) => {
        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('user-ticket/list/v1',{params: value}).then(list => {
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(orderSetListForExcel(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

export const list = (value) => {
    return (dispatch, getState) => {
        let states = getState()
        let userId;

        if(states.user.getItem && states.user.getItem._id) {
            userId = states.user.getItem._id
            value.technician_by = userId
        }

        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('user-ticket/list/v1',{params: value}).then(list => {
            if(list.status === 200) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }
            dispatch(orderSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}

const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.order.list,
        common       : state.common,
        initialValues: state.order.targetItem,
        listForExcel : state.user.listForExcel,
        userInfo     : state.user.getItem,
        areaList     : state.area.areaList,
        stateList     : state.area.stateList,
        cityList     : state.area.cityList,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
